// File: src/components/PromptViewerDialog.tsx
import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography,
    Box,
    Paper
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// Define the type for the component's props
interface PromptViewerDialogProps {
    open: boolean;
    onClose: () => void;
    prompt: { name: string; template: string } | null;
}

const PromptViewerDialog: React.FC<PromptViewerDialogProps> = ({ open, onClose, prompt }) => {
    return (
        <Dialog onClose={onClose} open={open} maxWidth="md" fullWidth>
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">
                        {/* Show prompt name or a default title */}
                        {prompt?.name || 'Prompt Template'}
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                {/* Fixing the visibility issue by explicitly setting
                    the background and text color, and using <pre> for formatting.
                */}
                <Paper
                    variant="outlined"
                    sx={{
                        p: 2,
                        bgcolor: 'rgba(30, 30, 30, 0.95)',
                        overflow: 'auto',
                        color: 'text.primary'
                    }}
                >
                    <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
                        <Typography sx={{ fontFamily: 'monospace' }}>
                            {prompt?.template}
                        </Typography>
                    </pre>
                </Paper>
            </DialogContent>
        </Dialog>
    );
};

export default PromptViewerDialog;